import { render, staticRenderFns } from "./FichaA4.vue?vue&type=template&id=03a840af&scoped=true&"
import script from "./FichaA4.vue?vue&type=script&lang=js&"
export * from "./FichaA4.vue?vue&type=script&lang=js&"
import style0 from "./FichaA4.vue?vue&type=style&index=0&id=03a840af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a840af",
  null
  
)

export default component.exports